import { useParams } from "react-router"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { parentFind } from "library/tree"
import { isPublishedId } from "library/id-helpers"
import { PlanRoot } from "library/tree/constants"
import { If } from "lib/@components/switch"
import { Box } from "@mui/material"
import { BadgeLabel } from "../plugins/regime-title/badge-label"
import { regimeStatusSx } from "../regime-status-pill"

export function InReviewLabel() {
    const { id } = useParams()
    const { editExtension, parentItem, payload, isRegimeDraftLocked } = useBoundContext()

    const isInRegime = parentFind(parentItem, (c) => c[PlanRoot])
    const show = !isPublishedId(id) && !!isInRegime && !!payload && !editExtension && isRegimeDraftLocked

    return (
        <If truthy={show}>
            <Box data-cy="schedule-in-review-label" pb={1} sx={{ zoom: 0.8 }}>
                <BadgeLabel sx={regimeStatusSx.review} badgeContent="In Review" />
            </Box>
        </If>
    )
}
